import { gql } from "@apollo/client";

const DeleteAccountMutation = gql`
  mutation DeleteAccountMutation($feedback: InputFeedback) {
    delete(feedback: $feedback) {
      deleted
    }
  }
`;

export default DeleteAccountMutation;
